import axios from 'axios';

const craApiUrl = process.env.REACT_APP_API_URL;
// Keep support for projects that already expose a VITE-style variable via process.env.
const viteStyleApiUrl = process.env.VITE_API_URL;

const resolvedApiUrl = craApiUrl ?? viteStyleApiUrl;
// Default to localhost:5000 if no API URL is provided
const rawApiUrl = (resolvedApiUrl || 'https://backend.toyotsu.autostream.lk').trim();
const normalizedApiUrl = rawApiUrl.replace(/\/+$/, '');
export const API_BASE_URL = /^https?:\/\//i.test(normalizedApiUrl)
  ? normalizedApiUrl
  : `http://${normalizedApiUrl}`;
const api = axios.create({
  baseURL: API_BASE_URL,
  // Do not set a default Content-Type: it breaks multipart uploads (profile pic, posts, etc.)
  // because the browser must set multipart/form-data with a boundary. JSON requests still
  // get application/json from axios transformRequest when the body is a plain object.
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    const h = config.headers;
    if (h && typeof (h as { delete?: (k: string) => void }).delete === 'function') {
      (h as { delete: (k: string) => void }).delete('Content-Type');
    } else if (h && typeof h === 'object') {
      delete (h as Record<string, unknown>)['Content-Type'];
    }
  }
  return config;
});

// Handle auth / authorization errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      // Cookie is missing or expired. Keep public auth pages accessible
      // during the initial session check on mount.
      const publicPaths = ['/login', '/signup', '/reset-password'];
      if (!publicPaths.includes(window.location.pathname)) {
        window.location.href = '/login';
      }
    } else if (status === 429) {
      error.message = 'Too many requests. Please wait a moment before trying again.';
    }

    return Promise.reject(error);
  },
);

export default api;
